import React from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";

export const BildUpload = ({toUserName,email,uploadOk}) => {
  const { getApiBaseUrl, user, userDaten } = LayoutData();
  const getAktion = () => {
    const url = getApiBaseUrl() + "api/userPicture";
    //console.log("url",url);
    return url;
  };

  const getUserName = () => {
    let userName=user.name;
    if (toUserName) userName=toUserName;
    console.log("upload nach ",userName,toUserName,email);
    return userName;
  };

  const uploadProps = {
    name: "profilePicture",
    data: { userName: getUserName() },
    action: getAktion(), // Ersetzen Sie dies durch Ihre tatsächliche Upload-URL
    headers: {
      authorization: "Bearer " + user.bearer,
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        uploadOk();
        console.log(`${info.file.name} wurde erfolgreich hochgeladen`);
      } else if (info.file.status === "error") {
        console.log(`${info.file.name} Upload fehlgeschlagen.`);
      }
    },
  };

  return (
    <Upload {...uploadProps}>
      <Button icon={<UploadOutlined />}>Bild hochladen</Button>
    </Upload>
  );
};
